import { connect } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';

const Loyalty = (props) => {
  const { customer } = props;
  const { settings } = props;
  const lifetimeValue = customer?.orderInformation?.lifetimeValue || 0;
  return (
    <div className="c7-account-tile">
      <h3>Loyalty</h3>
      <strong>Tier: {customer?.loyalty?.tier}</strong>
      <br />
      {customer?.loyalty?.points || 0} Points
      <br />
      Lifetime Value: {currencyFormat(lifetimeValue, settings)}
    </div>
  );
};

const mapStateToProps = (state) => ({
  customer: state.customer.data,
  settings: state.setting
});

export default connect(mapStateToProps)(Loyalty);
